import { APP_ENV, isAnalyticsDebug, isAnalyticsEnabled } from './config';
import { pushToDataLayer } from './dataLayer';
import { loadGtm } from './gtm';

export const initAnalytics = (): void => {
  try {
    if (!isAnalyticsEnabled) return;
    pushToDataLayer({ app_env: APP_ENV, ...(isAnalyticsDebug && { debug_mode: true }) });
    loadGtm();
  } catch {
    // ignored
  }
};

export { ANALYTICS_EVENTS } from './events';
export type { TAnalyticsEvent } from './events';
export { trackEvent } from './dataLayer';
export type { TAnalyticsParams } from './dataLayer';
export { pushToDataLayer as setUserProperties } from './dataLayer';
